'use client';

import { cn, Div } from '@scatterlab/zeta-core';
import { FC, memo, PropsWithChildren, useLayoutEffect, useRef } from 'react';

import { ZetaWatermarkRoom, ZetaWatermarkRoomWBg } from '../watermarks';

const heightBreakpoint = 37;

type WithWatermarkProps = PropsWithChildren<{
  showWatermark: boolean;
  edited?: boolean;
}>;

const WithWatermark: FC<WithWatermarkProps> = ({
  showWatermark,
  edited,
  children,
}) => {
  const divRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const divRefCurrent = divRef.current;
    if (divRefCurrent) {
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { height } = entry.contentRect;
          divRefCurrent.className = cn(
            'flex flex-row',
            height > heightBreakpoint ? 'items-end' : 'items-center',
          );
        }
      });

      observer.observe(divRefCurrent);

      return () => observer.disconnect();
    }
    return undefined;
  }, []);

  return (
    <Div ref={divRef}>
      {children}
      {showWatermark &&
        (edited ? <ZetaWatermarkRoom /> : <ZetaWatermarkRoomWBg />)}
    </Div>
  );
};

export default memo(WithWatermark);
